module.exports = __webpack_public_path__ + "static/media/sprinkler.0a626340.svg";